<template>
  <div v-if="isSuccess">
    <b-container fluid>
      <b-row>
        <b-col>
          <b-alert variant="info" :show="batches.length === 0">
            Vamos começar criando um lote?
            <router-link :to="{ name: 'OrganizerBatches' }">Criar lotes</router-link>
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="batches.length !== 0">
        <b-col cols="12" lg="8">
          <h2>{{ this.$gui.dealers }}</h2>

          <b-link class="d-block mb-1 d-lg-none" href="#cadastrar-novo">Cadastrar novo {{ $gui.dealerLC }}</b-link>

          <b-table v-if="dealerShop.length > 0" striped hover show-empty
            class="my-4"
            primary-key="id"
            :items="dealerShop"
            :fields="fieldsShop"
            responsive="md">

            <template v-slot:cell(actions)="data">

              <!-- Detalhar revendedor -->
              <b-button
                class="mr-1"
                v-b-tooltip.hover
                :title='`Detalhar ${data.item.name}`'
                @click="openDealerEdit(data.item.id)">
                <icon name="eye" class="mx-0"></icon>
              </b-button>

              <!-- Excluir revendedor -->
              <span
                v-b-tooltip.hover
                :title="data.item.print_amount > 0 ?
                  `${data.item.name} possui ingressos, não pode ser excluído` :
                  `Excluir ${data.item.name}`">

                <b-button variant="danger"
                  @click="deleteDealer(data.item)"
                  :disabled="data.item.print_amount > 0"
                >
                  <icon name="trash" class="mx-0"></icon>
                </b-button>
              </span>
            </template>

          </b-table>

          <b-form-group
            label-align="left"
            label-for="filterInput"
            class="my-4">
            <b-input-group>
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                :placeholder="'Pesquisar ' + this.$gui.dealersLC"
                 :autofocus="true"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-table striped hover show-empty
            primary-key="id"
            :items="dealers"
            :fields="fields"
            :filter="filter"
            responsive>

            <template v-slot:cell(access_web_n_app)="data">
              <toggle-button
                :value="data.item.token !== null"
                :sync="true" :width="45" :height="25"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="toggleToken(data.item)"
              />
            </template>

            <template v-slot:cell(reprint_enabled)="data">
              <toggle-button
                :value="data.item.reprint_enabled"
                :sync="true" :width="45" :height="25"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="toggleReprint(data.item)"
              />
            </template>

            <template v-slot:head(cancellation_enabled)="data">
              <div>
                {{ data.label }}
                <span v-b-tooltip.hover title="Define se a maquininha poderá cancelar vendas">
                  <icon name="info-circle" scale="0.8"></icon>
                </span>
              </div>              
            </template>

            <template v-slot:cell(cancellation_enabled)="data">
              <toggle-button
                :value="data.item.cancellation_enabled"
                :sync="true" :width="45" :height="25"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="toggleCancellation(data.item)"
              />
            </template>

            <template v-slot:head(self_service_mode_enabled)="">
              <div>
                Modo Autoatendimento
                <span v-b-tooltip.hover title="Oculta menus da maquininha, altera botão 'Vender' para 'Comprar', mantém tela sempre ligada e desabilita pagamento em dinheiro.">
                  <icon name="info-circle" scale="0.8"></icon>
                </span>
              </div>
            </template>

            <template v-slot:cell(self_service_mode_enabled)="data">
              <toggle-button
                :value="data.item.self_service_mode_enabled"
                :sync="true" :width="45" :height="25"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="toggleSelfServiceMode(data.item)"
              />
            </template>

            <template v-slot:cell(print_report_enabled)="data">
              <toggle-button
                :value="data.item.print_report_enabled"
                :sync="true" :width="45" :height="25"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="togglePrintReport(data.item)"
              />
            </template>

            <template v-slot:cell(actions)="data">

              <!-- Copiar link loja revendedor -->
              <b-button
                class="mr-1"
                v-b-tooltip.hover
                :title="`Copiar link da loja de ${data.item.name}`"
                @click="copyLinkPromoter(data.item)">
                <icon name="link" class="mx-0"></icon>
              </b-button>

              <!-- Detalhar revendedor -->
              <b-button
                class="mr-1"
                v-b-tooltip.hover
                :title='`Detalhar ${data.item.name}`'
                @click="openDealerEdit(data.item.id)">
                <icon name="eye" class="mx-0"></icon>
              </b-button>

              <!-- Excluir revendedor -->
              <span
                v-b-tooltip.hover
                :title="data.item.print_amount > 0 ?
                  `${data.item.name} possui ingressos, não pode ser excluído` :
                  `Excluir ${data.item.name}`">

                <b-button variant="danger"
                  @click="deleteDealer(data.item)"
                  :disabled="data.item.print_amount > 0"
                >
                  <icon name="trash" class="mx-0"></icon>
                </b-button>
              </span>
            </template>

          </b-table>
        </b-col>

        <!-- Criar revendedor -->
        <b-col cols="12" lg="4">
          <div id="cadastrar-novo" class="p-4" style="position: sticky; top: 0; background-color: #f8fbff;">
            <h2>Novo {{ this.$gui.dealerLC }}</h2>

            <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
              @dismissed="feedback.show=false">
                {{ feedback.data }}
            </b-alert>

            <b-form @submit.prevent="createDealer">
              <b-form-group
                description="Exemplos: Bilheteria, Açaí Brasil, Organizador">

                  <p class="mb-2 font-weight-bold">Nome do {{ $gui.dealerLC }}</p>
                  <b-form-input
                    type="text"
                    v-model="form.name"
                    required>
                  </b-form-input>
              </b-form-group>

              <b-form-group>
                <p class="mb-2 font-weight-bold">Escolha os {{ $gui.batchesLC }} para ativar:</p>

                <b-form-checkbox class="mb-3 text-primary" v-if="batches.length > 1" v-model="allBatchesSelected" @change="selectAllBatches">Marcar todos {{ $gui.batchesLC }}</b-form-checkbox>
                
                <b-form-checkbox-group stacked v-model="form.batches">
                  <b-form-checkbox class="mb-2"
                    v-for="batch in batches"
                    :key="batch.id"
                    :value="batch.id"
                    @change="selectOneBatch">
                      {{ batch.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>

              <b-button type="submit" variant="primary" class="mt-3">Cadastrar {{ this.$gui.dealerLC }}</b-button>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <modal v-if="showModal" ref="modal">
      <router-view name="content"/>
    </modal>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'
import Modal from '@/components/Modal'
import copy from 'copy-to-clipboard'

const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

const slugify = require('slugify')

export default {
  name: 'OrganizerDealers',
  components: {
    ToggleButton,
    Modal
  },
  data () {
    return {
      showModal: this.$route.meta.showModal,
      currentStatus: null,
      organizer: '',
      batches: [],
      dealers: [],
      dealer: {},
      dealerShop: {},
      filter: null,
      fields: [
        {key: 'name', label: 'Nome', sortable: true, class: ['align-middle'], thStyle: { minWidth: '250px' }, tdStyle: { minWidth: '250px' } },
        {key: 'access_web_n_app', label: 'Impressão via Web e App', class: ['text-center', 'align-middle'] },
        {key: 'reprint_enabled', label: 'Pode reimprimir?', class: ['text-center', 'align-middle'] },
        {key: 'cancellation_enabled', label: 'Pode cancelar?', class: ['text-center', 'align-middle'] },
        {key: 'self_service_mode_enabled', label: 'Modo Autoatendimento', class: ['text-center', 'align-middle'] },
        {key: 'print_report_enabled', label: 'Pode imprimir relatório?', class: ['text-center', 'align-middle'] },
        {key: 'actions', label: 'Ações', class: ['text-nowrap', 'text-center', 'align-middle'] }
      ],
      fieldsShop: [
        {key: 'name', label: 'Nome', class: ['align-middle'] },
        {key: 'actions', label: 'Ações', class: ['text-center', 'align-middle'] }
      ],
      event_name: '',
      event_id: '',
      form: {
        name: '',
        batches: [],
        type: 'seller'
      },
      feedback: {
        data: '',
        type: '',
        show: false
      },
      allBatchesSelected: false
    }
  },
  watch: {
    '$route.meta' ({showModal}) {
      this.showModal = showModal
    },
    '$route' (to, from) {
      if (from.name === 'OrganizerBatchEdit' && to.name === 'OrganizerBatches') {
        this.getEvent()
      }
    }
  },
  mounted () {
    this.organizer = this.$route.params.organizer
    this.getEvent()
  },
  methods: {
    selectAllBatches (checked) {
      this.form.batches = []
      if (!checked) return
      for (let x = 0; x < this.batches.length; x++) {
        this.form.batches.push(this.batches[x].id)
      }
    },
    selectOneBatch () {
      this.allBatchesSelected = false
    },
    async toggleReprint (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}/toggle-reprint`
      let i = this.$_.findIndex(this.dealers, d => d.id === dealer.id)

      try {
        let resp = await this.$http.patch(endpoint, {})
        if (resp.ok) {
          this.dealers[i].reprint_enabled = 1 - this.dealers[i].reprint_enabled
          return true
        }
      } catch (e) {
        console.err(e)
        return false
      }
    },
    async toggleCancellation (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}/toggle-cancellation`
      let i = this.$_.findIndex(this.dealers, d => d.id === dealer.id)

      try {
        let resp = await this.$http.patch(endpoint, {})
        if (resp.ok) {
          this.dealers[i].cancellation_enabled = 1 - this.dealers[i].cancellation_enabled
          return true
        }
      } catch (e) {
        console.error(e)
        return false
      }
    },
    async toggleSelfServiceMode (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}/toggle-self-service-mode`
      let i = this.$_.findIndex(this.dealers, d => d.id === dealer.id)

      try {
        let resp = await this.$http.patch(endpoint, {})
        if (resp.ok) {
          this.dealers[i].self_service_mode_enabled = 1 - this.dealers[i].self_service_mode_enabled
          return true
        }
      } catch (e) {
        console.err(e)
        return false
      }
    },
    async togglePrintReport (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}/toggle-print-report`
      let i = this.$_.findIndex(this.dealers, d => d.id === dealer.id)

      try {
        let resp = await this.$http.patch(endpoint, {})
        if (resp.ok) {
          this.dealers[i].print_report_enabled = 1 - this.dealers[i].print_report_enabled
          return true
        }
      } catch (e) {
        console.err(e)
        return false
      }
    },
    async toggleToken (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}/tokens`
      let i = this.$_.findIndex(this.dealers, d => d.id === dealer.id)

      try {
        if (dealer.token) {
          await this.$http.delete(endpoint)
          this.dealers[i].token = null
        } else {
          let resp = await this.$http.post(endpoint, {})
          this.dealers[i].token = resp.body.token
        }
      } catch (e) {
        console.err(e)
      }
    },
    linkPromoter (dealer) {
      return process.env.VUE_APP_URL_LOJA + '/' +
        this.event_id + '-' + slugify(this.event_name, {lower: true}) + '/' +
        dealer.id + '-' + slugify(dealer.name, {lower: true})
    },
    copyLinkPromoter (dealer) {
      copy(this.linkPromoter(dealer))

      this.$bvToast.toast(`Link da loja copiado com sucesso`, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: 'success'
      })
    },
    getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      return this.$http.get(url).then(res => {
        this.event_name = res.body.name
        this.event_id = res.body.id

        if (res.body.dealers.length > 0) {
          let allDealers = this.$_.partition(res.body.dealers, d => d.type === 'online')

          this.dealerShop = allDealers[0]
          this.dealers = this.$_.orderBy(allDealers[1], ['type', 'id'], ['asc'])
        }

        if (res.body.batches.length > 0) {
          let batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
          this.batches = this.$_.filter(batches, b => b.is_available === 1)
        }
        this.currentStatus = STATUS_SUCCESS
      }, err => {
        console.log(err)
        this.currentStatus = STATUS_FAILED
      })
    },
    async createDealer () {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers`
      let variant = ''
      let msg = ''

      try {
        let resp = await this.$http.post(endpoint, this.form)

        variant = 'success'
        msg = `${this.form.name} criado!`

        this.dealers.push(resp.body)

        this.form.name = null
        this.form.batches = []
      } catch (err) {
        variant = 'danger'
        msg = err.body.message
      }

      this.$bvToast.toast(msg, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: variant
      })
    },
    async deleteDealer (dealer) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${dealer.id}`
      let variant = 'danger'
      let msg = ''

      try {
        await this.$http.delete(endpoint)
        this.dealers = this.$_.filter(this.dealers, d => d.id !== dealer.id)
        msg = `${dealer.name} excluído!`
      } catch (err) {
        msg = err.body.message
      }

      this.$bvToast.toast(msg, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        variant: variant
      })
    },
    openDealerEdit (dealerId) {
      this.$router.push({name: 'OrganizerDealer', params: { id: dealerId }})
    },
    updateDealer (dealer) {
      this.dealer = dealer
    },
    link (token) {
      if (token === undefined || token === null) {
        return null
      }
      let route = this.$router.resolve({
        name: 'DealerOverview',
        params: {
          dealer: token
        }
      })
      return process.env.VUE_APP_URL_APP + route.href
    },
    createToken (dealerId) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer +
        '/dealers/' + dealerId +
        '/tokens'

      this.$http.post(url, {}).then(res => {
        let i = this.$_.findIndex(this.dealers, d => d.id === dealerId)
        this.dealers[i].token = res.body.token
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    },
    deleteToken (dealerId) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer +
        '/dealers/' + dealerId +
        '/tokens'

      this.$http.delete(url).then(res => {
        let i = this.$_.findIndex(this.dealers, d => d.id === dealerId)
        this.dealers[i].token = null
      }, err => {
        alert(err.body.message)
        console.log(err)
      })
    }
  },
  computed: {
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    batchesNames () {
      return this.$_.map(this.batches, b => b.name)
    }
  }
}
</script>
